// @ts-nocheck

export type TicketGetWithTicketCommentsContactToTenant = typeof TicketGetWithTicketCommentsContactToTenant[keyof typeof TicketGetWithTicketCommentsContactToTenant];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TicketGetWithTicketCommentsContactToTenant = {
  true: 'true',
  false: 'false',
} as const;
